import { ScrapbookFile } from '@/api/scrapbook-data';
import ContentPreviewWraper from './ContentPreviewWraper';

import saveAs from 'file-saver';
import { GeneralImage } from '@/components';
import { getIcon } from '@/utils/scrapbookUtils';
import { ImageModel } from '@/types';

interface FilePreviewProps {
  content: ScrapbookFile | null;
  onClose: () => void;
}
const FilePreview = ({ content, onClose }: FilePreviewProps) => {
  const handleDownload = async () => {
    try {
      if (content?.blobUri) {
        // For blob files, download directly
        saveAs(content.blobUri, content.name);
      } else {
        // For other files, we might need to implement download logic
        console.log('Download not implemented for non-blob files');
      }
    } catch (error) {
      console.error('Download failed:', error);
    }
  };

  const createImageModel = (file: ScrapbookFile): ImageModel => ({
    imageUrl: file.blobUri || '',
    imageAlt: file.name,
    caption: file.content?.imageCaption || '',
    copyrightText: file.content?.imageCopyright || '',
    mediaId: 0,
  });

  const isImage = content?.contentType?.startsWith('image/');
  const IconComponent = getIcon(content?.contentType || '');
  return (
    <ContentPreviewWraper
      content={content}
      onClose={onClose}
      title="User Files"
      subTitle={content?.name}
      onDownload={handleDownload}
    >
      {isImage ? (
        <div className="flex h-full flex-col items-center justify-center">
          <div className="flex h-full flex-col">
            <div className="h-full overflow-hidden">
              <GeneralImage
                image={createImageModel(content!)}
                widths={{ lg: 1024, xl: 1428 }}
                showCopyrightText
                disableClick
                dataNotLazy
                className="[&_.buttons]:hidden"
              />
            </div>
          </div>
        </div>
      ) : (
        <div className="px-4 py-3">
          <div className="flex">
            <div className="flex-1 text-center">
              <div className="px-32">
                <div className="flex flex-col items-center justify-center py-10">
                  <IconComponent className="mb-4 h-32 w-32 text-gray-400" />
                  <div className="text-lg font-medium text-gray-900">{content?.name}</div>
                  <div className="mt-2 text-sm text-gray-600">{content?.contentType || 'Unknown file type'}</div>
                  {content?.lastModified && (
                    <div className="mt-1 text-sm text-gray-500">
                      Modified: {new Date(content?.lastModified).toLocaleDateString()}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </ContentPreviewWraper>
  );
};

export default FilePreview;
